import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { ContentControlDataProtectionRule } from '@nirvana/shared/dtos/types/policies/common';
import { SetFiltersRequest } from '../../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';
import { sortByColumn } from './utils/sorters';

export class GzContentControlDataProtectionRulesGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ContentControlDataProtectionRule
> {
  sortByColumnMethod(
    a: ContentControlDataProtectionRule,
    b: ContentControlDataProtectionRule,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.NAME);
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.STRING);
    return;
  }
}
